import { unreadModularObjectsVar } from '@/apollo/localVariables';
import { useReactiveVar } from '@apollo/client';

export const useUnreadModularObjects = (id: string) => {
  return useReactiveVar(unreadModularObjectsVar)[id];
};
